import React, { useState }  from "react";
import { Button } from "react-bootstrap";
import FormSection from "components/sales/formSection/formSectionNew";
import CardSection from "components/sales/cardSection/cardSection";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";

const yesNoOptions = [
  { id: 1, name: "Yes" },
  { id: 0, name: "No" },
];

const ItemRequestForm = ({
  formData,
  handleInputChange,
  handleSubmit,
  dropdownData,
  brandAndHsnData,
  setFormData,
  isLoading,
  isEdit = false,
}) => {
    
  const handleCancel = () => {
    window.history.back();
  };

  return (
    <FormSection>
      {/* ---------------- ITEM SECTION ---------------- */}
      <CardSection title="Item">
        <div className="row">
          <div className="col-md-6">
            <ConstantInput
              label="Name"
              name="name"
              value={formData.name}
              handleChange={(value) => setFormData((prev) => ({...prev,name: value,}))}
              isStarRequired
            />
          </div>

          <div className="col-md-6">
            <ConstantInput
              label="Description"
              name="description"
              value={formData.description}
              handleChange={(value) => setFormData((prev) => ({...prev,description: value,}))}
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Type"
              data={[
                      {id: "Inventory", name: "Inventory"},
                      {id: "Service", name: "Service"},
                      // {id: "Non-Inventory", name: "Non-Inventory"},
                    ]}
              getValueById={formData?.type}
              isStarRequired
              getIdValue={(val) => handleInputChange({ target: { name: "type", value: val } })}
              disabled = {isEdit}
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Class of Material"
              data={[
                        {id: 1, name: "A"},
                        {id: 2, name: "B"},
                        {id: 3, name: "C"},
                        {id: 4, name: "Service"},
                        {id: 5, name: "Non-Inventory"},
                    ]}
              getValueById={formData?.class_of_material}
              getIdValue={(val) =>
                handleInputChange({ target: { name: "class_of_material", value: val } })
              }
              isStarRequired
              disabled = {isEdit || formData.type == 'Service'}
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="UOM"
              data={dropdownData?.uom || []}
              getValueById={formData?.base_unit_of_measure}
              getIdValue={(val) =>
                handleInputChange({ target: { name: "base_unit_of_measure", value: val } })
              }
              isStarRequired
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="QC Enable"
              data={yesNoOptions}
              getValueById={formData?.qc_enable}
              getIdValue={(val) => handleInputChange({ target: { name: "qc_enable", value: val } })}
            />
          </div>  

          <div className="col-md-6"> 
            <DropDownInput
                label="Category"
                data={dropdownData?.categories || []}
                getValueById={formData?.item_category_code}
                getIdValue={(val) => {
                    handleInputChange({ target: { name: "item_category_code", value: val } });
                }}
                isStarRequired = {formData?.type != 'Service'}
            />
          </div>

          <div className="col-md-6"> 
            <DropDownInput
              label="Brand"
              data={dropdownData?.brands || []}
              controlledValue={formData?.brand}
              getValueById={formData?.brand}
              getIdValue={(val) =>
                handleInputChange({ target: { name: "brand", value: val } })
              }
              isStarRequired = {formData?.type != 'Service'}
            />
          </div>  

          <div className="col-md-6"> 
            <DropDownInput
              label="Tag"
              data={yesNoOptions}
              getValueById={formData?.tag}
              getIdValue={(val) =>
                handleInputChange({ target: { name: "tag", value: val } })
              }
              disabled
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Revenue Type"
              data={[
                        {id: "V", name: "Variable"},
                        {id: "F", name: "Fixed"},
                        {id: "O", name: "On Demand"},
                        {id: "C", name: "Consumable"},
                        {id: "S", name: "Software"},
                    ]}
              getValueById={formData?.revenue_type}
              getIdValue={(val) =>
                handleInputChange({ target: { name: "revenue_type", value: val } })
              }
            />
          </div>

          {isEdit && 
            <div className="col-md-6">
              <ConstantInput
                label="Remarks"
                name="remarks"
                value={formData.remarks}
                handleChange={(value) => setFormData((prev) => ({...prev,remarks: value,}))}
                isStarRequired
              />
            </div>
          }
        </div>
      </CardSection>

      {/* ---------------- COST & POSTING SECTION ---------------- */}
      <CardSection title="Costs & Posting">
        <div className="row">
          <div className="col-md-6">
            <ConstantInput
              label="Unit Cost"
              name="unit_cost"
              type="number"
              step="0.01"
              value={formData.unit_cost}
              handleChange={(value) => setFormData((prev) => ({...prev,unit_cost: value,}))}
              isStarRequired
            />
          </div>  

          <div className="col-md-6">
            <DropDownInput
              label="Gen. Prod. Posting Group"
              data={dropdownData?.genPosting || []}
              getValueById={formData?.gen_prod_posting_group}
              getIdValue={(val) =>
                handleInputChange({ target: { name: "gen_prod_posting_group", value: val } })
              }
            />
          </div>  

          {formData.type != 'Service' &&
            <div className="col-md-6">
              <DropDownInput
                label="Inventory Posting Group"
                data={dropdownData?.invPostingGroup || []}
                getValueById={formData?.inventory_posting_group}
                getIdValue={(val) =>
                  handleInputChange({ target: { name: "inventory_posting_group", value: val } })
                }
              />
            </div>
          }
        </div>
      </CardSection>

      {/* ---------------- INVENTORY ---------------- */}
      {formData.type != 'Service' &&
        <CardSection title="Inventory">
          <div className="row">
            <div className="col-md-6">
              <ConstantInput
                label="Unit Volume"
                name="unit_volume"
                type="number"
                step="0.01"
                value={formData.unit_volume}
                handleChange={(value) => setFormData((prev) => ({...prev,unit_volume: value,}))}
              />
            </div>

            <div className="col-md-6">
              <ConstantInput
                label="Net Weight"
                name="net_weight"
                type="number"
                step="0.01"
                value={formData.net_weight}
                handleChange={(value) => setFormData((prev) => ({...prev,net_weight: value,}))}
              />
            </div>  

            <div className="col-md-6">
              <ConstantInput
                label="Gross Weight"
                name="gross_weight"
                type="number"
                step="0.01"
                value={formData.gross_weight}
                handleChange={(value) => setFormData((prev) => ({...prev,gross_weight: value,}))}
              />
            </div>
          </div>
        </CardSection>
      }

      {/* ---------------- PRICES & SALES SECTION ---------------- */}
      <CardSection title="Prices & Sales">
        <div className="row">
          <div className="col-md-6">
            <ConstantInput
              label="Unit Price"
              name="unit_price"
              type="number"
              step="0.01"
              value={formData.unit_price}
              handleChange={(value) => setFormData((prev) => ({...prev,unit_price: value,}))}
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="Sales Unit of Measure"
              data={dropdownData?.uom || []}
              getValueById={formData?.base_unit_of_measure}
              getIdValue={(val) =>
                handleInputChange({ target: { name: "base_unit_of_measure", value: val } })
              }
              disabled
            />
          </div>
        </div>  
      </CardSection>

      {/* ---------------- GST DETAILS ---------------- */}
      <CardSection title="GST Details">
        <div className="row">
          <div className="col-md-6">
            <DropDownInput
                label="GST Group Code"
                data={dropdownData?.gst || []}
                getValueById={formData?.gst_group_code}
                getIdValue={(val) => {
                    handleInputChange({ target: { name: "gst_group_code", value: val } });
                }}
                isStarRequired
            />
          </div>

          <div className="col-md-6">
            <DropDownInput
              label="HSN/SAC Code"
              data={brandAndHsnData?.hsn}
              controlledValue={formData?.hsn_sac_code}
              getValueById={formData?.hsn_sac_code}
              getIdValue={(val) =>
                handleInputChange({ target: { name: "hsn_sac_code", value: val } })
              }
              isStarRequired
            />
          </div>
        </div>
      </CardSection>

      {/* ---------------- ITEM TRACKING ---------------- */}
      {formData.type != 'Service' &&
        <CardSection title="Item Tracking">
          <div className="row">
            <div className="col-md-6">
              <DropDownInput
                label="Item Tracking Code"
                data={dropdownData?.track || []}
                getValueById={formData?.item_tracking_code}
                getIdValue={(val) =>
                  handleInputChange({ target: { name: "item_tracking_code", value: val } })
                }
              />
            </div>  

            <div className="col-md-6">  
              <DropDownInput
                label="Serial No."
                data={dropdownData?.serialNo || []}
                getValueById={formData?.serial_no}
                getIdValue={(val) =>
                  handleInputChange({ target: { name: "serial_no", value: val } })
                }
                disabled = {formData.item_tracking_code == 'QR'}
              />
            </div>

            <div className="col-md-6">  
              <DropDownInput
                label="QR Code"
                data={yesNoOptions}
                getValueById={formData?.qr_code}
                getIdValue={(val) => handleInputChange({ target: { name: "qr_code", value: val } })}
                disabled
              />
            </div>
          </div>
        </CardSection>
      }

      {/* ---------------- SUBMIT ---------------- */}
      <div className="form-action-buttons">
        <Button variant="primary" onClick={handleSubmit}>
          {isEdit ? "Update" : "Submit"}
        </Button>
      </div>
    </FormSection>
  );
};

export default ItemRequestForm;
